<template>
  <EmdFormGroup
    :label="$t('birth-date')"
    :state="getState($v.recipient.birth_date)"
    :feedbacks="feedbacks($v.recipient.birth_date)"
    required
  >
    <EmdInput
      @input="updateField"
      v-model="birth_date"
      placeholder="DD/MM/AAAA"
      name="birth_date"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { managingPartners } from '../validations'

export default {
  name: 'Birth_dateInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    birth_date: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: managingPartners }
  },
  methods: {
    updateField (value) {
      const dateParts = value.split('/').reverse()
      const year = dateParts[0]
      const month = dateParts[1]
      const day = dateParts[2]

      if (year && month && day) {
        this.$set(this.recipient, 'birth_date', `${year}-${month}-${day}`)
      } else {
        this.$set(this.recipient, 'birth_date', '')
      }

      this.$v.recipient.birth_date.$touch()
    }
  },
  mounted () {
    if (this.recipient.birth_date) {
      const [year, month, day] = this.recipient.birth_date.split('-')
      this.birth_date = `${day}/${month}/${year}`
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "birth-date": "Data de nascimento"
    },
    "en-US": {
      "birth-date": "Founding date"
    }
  }
</i18n>
